import { isMobile, isTablet } from 'react-device-detect';

var mult = isMobile || isTablet ? 2 : 1;

export const WildItem = {
	name: 'WildItem',
	position: {
		x: 0,
		y: 0
	},
	components: [
		{
			name: 'wild',
			type: 'AnimatedSprite',
			position: { x: 0, y: 0 },
			animation: {
				pattern: 'Pump$.png',
				start: 0,
				end: 47,
				speed: 0.5,
				precision: 2,
				loop: true,
				scale: {
					x: 1 * mult,
					y: 1 * mult
				}
			}
		},
		{
			name: 'wild',
			type: 'AnimatedSprite',
			position: { x: 5, y: 140 },
			animation: {
				pattern: 'wild5$.png',
				start: 0,
				end: 23,
				speed: 0.5,
				loop: true,
				precision: 2,
				scale: {
					x: mult,
					y: mult
				}
			}
		}
	]
};
